"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var articleApi = _interopRequireWildcard(require("@/api/article.js"));
var storeApi = _interopRequireWildcard(require("@/api/product.js"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  // name: "edit"
  props: {
    prent: {
      type: Object,
      required: true
    },
    isCreate: {
      type: Number,
      default: 0
    },
    editData: {
      type: Object
    },
    biztype: {
      type: Object,
      required: true
    },
    allTreeList: {
      type: Array
    }
  },
  data: function data() {
    return {
      loadingBtn: false,
      constants: this.$constants,
      editPram: {
        icon: null,
        name: null,
        pid: null,
        sort: 0,
        // status: true,
        type: this.biztype.value,
        url: null,
        id: 0
      },
      categoryProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        expandTrigger: 'hover',
        checkStrictly: true,
        emitPath: false
      },
      parentOptions: []
    };
  },
  mounted: function mounted() {
    this.initEditData();
  },
  methods: {
    handleChange: function handleChange() {
      this.prent.level = this.$refs['cascader'].getCheckedNodes()[0].level;
    },
    // 点击图标
    addIcon: function addIcon() {
      var _this = this;
      _this.$modalIcon(function (icon) {
        _this.editPram.icon = icon;
      });
    },
    // 点击商品图
    modalPicTap: function modalPicTap(multiple) {
      var _this = this;
      var attr = [];
      this.$modalUpload(function (img) {
        if (!img) return;
        _this.editPram.icon = img[0].sattDir;
      }, multiple, 'store');
    },
    close: function close() {
      this.$emit('hideEditDialog');
    },
    initEditData: function initEditData() {
      this.parentOptions = _toConsumableArray(this.allTreeList);
      this.addTreeListLabelForCasCard(this.parentOptions, 'child');
      var _this$editData = this.editData,
        icon = _this$editData.icon,
        name = _this$editData.name,
        pid = _this$editData.pid,
        sort = _this$editData.sort,
        type = _this$editData.type,
        id = _this$editData.id,
        url = _this$editData.url,
        level = _this$editData.level;
      if (this.isCreate === 1) {
        this.editPram.icon = icon;
        this.editPram.name = name;
        this.editPram.pid = pid;
        this.editPram.sort = sort;
        this.editPram.type = type;
        this.editPram.url = url;
        this.editPram.id = id;
        this.editPram.level = level;
      } else {
        this.editPram.pid = this.prent.id;
        this.editPram.type = this.biztype.value;
        this.editPram.level = parseInt(this.prent.level) + 1;
      }
    },
    addTreeListLabelForCasCard: function addTreeListLabelForCasCard(arr, child) {
      var _this2 = this;
      arr.forEach(function (item) {
        _this2.treeListCheckLevelLT3ForDisabled(item.children);
      });
    },
    treeListCheckLevelLT3ForDisabled: function treeListCheckLevelLT3ForDisabled(children) {
      var _this3 = this;
      if (!children) return;
      children.forEach(function (j) {
        if (j.level >= 3) {
          j.disabled = true;
        } else _this3.treeListCheckLevelLT3ForDisabled(j.children);
      });
    },
    handlerSubmit: function handlerSubmit(formName) {
      var _this4 = this;
      this.$refs[formName].validate(function (valid) {
        if (!valid) return;
        _this4.handlerSaveOrUpdate(_this4.isCreate === 0);
      });
    },
    handlerSaveOrUpdate: function handlerSaveOrUpdate(isSave) {
      var _this5 = this;
      if (isSave) {
        // this.editPram.pid = this.prent.id
        this.loadingBtn = true;
        if (this.biztype.value !== 2) {
          if (this.editPram.pid === 0) this.editPram.level = 1;
          if (!this.editPram.level) this.editPram.level = parseInt(this.prent.level) + 1;
          storeApi.productCategoryAddApi(this.editPram).then(function (data) {
            _this5.$emit('hideEditDialog');
            _this5.$message.success('创建目录成功');
            _this5.$store.commit('product/SET_AdminProductClassify', []);
            _this5.loadingBtn = false;
          }).catch(function () {
            _this5.loadingBtn = false;
          });
        } else {
          articleApi.articleCategoryAddApi(this.editPram).then(function (data) {
            _this5.$emit('hideEditDialog');
            _this5.$message.success('创建目录成功');
            localStorage.removeItem('articleClass');
            _this5.loadingBtn = false;
          }).catch(function () {
            _this5.loadingBtn = false;
          });
        }
      } else {
        this.loadingBtn = true;
        if (this.biztype.value !== 2) {
          if (this.editPram.pid === this.editData.id) return this.$message.warning('父级不能选当前分类');
          storeApi.productCategoryUpdateApi(this.editPram).then(function (data) {
            _this5.$emit('hideEditDialog');
            _this5.$message.success('更新目录成功');
            _this5.$store.commit('product/SET_AdminProductClassify', []);
            _this5.loadingBtn = false;
          }).catch(function () {
            _this5.loadingBtn = false;
          });
        } else {
          this.editPram.pid = Array.isArray(this.editPram.pid) ? this.editPram.pid[0] : this.editPram.pid;
          articleApi.articleCategoryUpdateApi(this.editPram).then(function (data) {
            _this5.$emit('hideEditDialog');
            _this5.$message.success('更新目录成功');
            localStorage.removeItem('articleClass');
            _this5.loadingBtn = false;
          }).catch(function () {
            _this5.loadingBtn = false;
          });
        }
      }
    }
  }
};